/* istanbul ignore file */
export const migrationEndpoints = {
  legalEnityMigrationConsnets: (legalEntityId: number, processSlug: string = 'DN-CUSTOMER-MIGRATION-1') => {
    return `/consents/v1/legal-entities/${legalEntityId}/processes/${processSlug}/consents`;
  },
  migrate: '/migration/customer/migrate',
  acceptTnC: (legalEntityId: number) => {
    return `/cuba/customer/v2/legal/own/terms/${legalEntityId}`;
  },
  acceptConsent: (uuid: string, slug: string) => {
    return `/consents/v1/customers/${uuid}/consents/${slug}`;
  },
};

export const migrationContentfulKeys = {
  generalTnC: '17ENIOiQEtfMqwKv5xteDN',
};
